import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';
import { CopyTooltip } from '@ltvco/refresh-lib/utils';
import { Logout } from '@mui/icons-material';

import {
  LinkButton,
  StyledAdditionalInfoStack,
  StyledLogoutButtonStack,
} from 'components/DeepSearch/components/AccountPage/sections/NeedAssistance/components';
import { theme } from 'theme';

interface AdditionalInfoProps {
  memberId: string;
  onLogoutClick: () => void;
}

export const AdditionalInfo = ({
  memberId,
  onLogoutClick,
}: AdditionalInfoProps) => {
  return (
    <StyledAdditionalInfoStack>
      <Text variant="body2" fontWeight="400" gap={'16px'} textAlign="center">
        When contacting customer <br /> care use:
      </Text>
      <Text variant="body2" fontWeight="700">
        Member ID:{' '}
        <CopyTooltip
          value={memberId}
          iconStyles={{
            color: theme.palette.primary.main,
          }}
          buttonStyles={{
            verticalAlign: 'unset',
            fontWeight: '400',
            fontStyle: 'normal',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {memberId}
        </CopyTooltip>
      </Text>
      <Divider sx={{ width: '100%' }} />
      <StyledLogoutButtonStack>
        <LinkButton
          sx={{ textDecoration: 'none' }}
          onClick={onLogoutClick}
          data-cy="log_out_btn"
        >
          <Stack direction="row" spacing={1}>
            <Logout sx={{ fontSize: '20px' }} />
            <Text fontWeight="bold">Logout</Text>
          </Stack>
        </LinkButton>
      </StyledLogoutButtonStack>
    </StyledAdditionalInfoStack>
  );
};
